(function($) {

    $('.m-flexible-testimonials__slides').slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        pauseOnHover: false,
        speed: 1000,
        fade: true
    });
	
	$('.m-flexible-logos__slides--carousel').slick({
		arrows: false,
		autoplay: true,
		autoplaySpeed: 4000,
		dots: false,
		pauseOnHover: false,
		responsive: [
			{
				breakpoint: 960,
				settings: {
					slidesToScroll: 3,
					slidesToShow: 3
				}
			},
			{
				breakpoint: 720,
				settings: {
					slidesToScroll: 2,
					slidesToShow: 2
				}
			}
		],
		slide: 'div',
		slidesToScroll: 4,
		slidesToShow: 4,
		speed: 750
	});

})(jQuery);